module.exports = __webpack_public_path__ + "static/media/dn-joseph.489ba045.jpg";